import { OktaAuth } from '@okta/okta-auth-js';

// Okta configuration for OAuth2 Authorization Code flow with PKCE
// This moves MFA handling to Okta's hosted login page, eliminating server-side polling timeouts
const oktaConfig = {
    // Issuer URL from database admin.identity_provider_config
    issuer: import.meta.env.VITE_OKTA_ISSUER || 'https://khkgames.okta.com/oauth2/default',

    // Client ID from database admin.identity_provider_config
    clientId: import.meta.env.VITE_OKTA_CLIENT_ID || '0oa1zmnz4tavMZod51d8',

    // Redirect URI after Okta authentication completes
    redirectUri: `${window.location.origin}/login/callback`,

    // Post-logout redirect
    postLogoutRedirectUri: `${window.location.origin}/login`,

    // Scopes - include 'groups' for RBAC claims
    scopes: ['openid', 'profile', 'email', 'groups', 'offline_access'],

    // Use PKCE for SPA security (no client secret needed)
    pkce: true,

    // Token storage - use localStorage for persistence across tabs.
    // autoRenew is activated by @okta/okta-vue's plugin install (it calls
    // oktaAuth.start(), required for autoRenew to run in okta-auth-js v8+).
    tokenManager: {
        storage: 'localStorage',
        autoRenew: true,
        // NOTE: okta-auth-js v8 locks expireEarlySeconds to the 30s default in
        // non-dev (prod) environments; this 300 only takes effect on a dev issuer.
        expireEarlySeconds: 300
    }
};

// Create OktaAuth instance
const oktaAuth = new OktaAuth(oktaConfig);

export { oktaAuth, oktaConfig };
export default oktaAuth;
